import { UnknownAction } from 'redux';

export const FILTER = 'KRETS_FILTER';

export interface SelectedKrets {
  value: number;
  label: string;
}

export interface KretsAction extends UnknownAction {
  selected: SelectedKrets[];
}

export function selectKretsAction(selected: SelectedKrets[]): KretsAction {
  return {
    type: FILTER,
    selected: [].concat(selected || []),
  };
}
